import styles from '../../../pages/LeadCapture/ExhibitorLeads/ExhibitorLeads.module.css'

// ------ Components ------ //
import QualifierItem from '../../../components/LeadCapture/ExhibitorLeads/QualifierItem'
const LeadItem = ({ index, lead }) => {    
    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        };
        return date.toLocaleDateString('en-us', options);
    }
    return (
        <>
            <tr className={styles.trLeads} key={index}>
                <td className={styles.tdLeads}> {lead.scannerField}</td>
                <td className={styles.tdLeads}> {lead.firstName} {lead.lastName}</td>
                <td className={styles.tdLeads}> {lead.organization}</td>
                <td className={styles.tdLeads}> {lead.emailAddress}</td>
                <td className={styles.tdLeads}> {lead.city}</td>
                <td className={styles.tdLeads}> {lead.state}</td>
                <td className={styles.tdLeads}> {lead.country}</td>
                <td className={styles.tdLeads}> {changeDateTimeFormat(lead.scanDate)}</td>
                <td className={styles.tdLeads}> {lead.qualifiers && lead.qualifiers.length > 0 ?
                    <ul key={lead.qualifiers.length} className={styles.ulQualifier}>
                                                {lead.qualifiers.map((item, index) => (
                                                    <QualifierItem
                                                        index={index}
                                                        qualifier={item}
                                                    >
                                                    </QualifierItem>
                                                ))}
                                            </ul>
                    : ''}</td>
                <td className={styles.tdLeads}> {lead.notes ? lead.notes : ''}</td>
                <td className={styles.tdLeads}> {lead.maxAllowed}</td>
                
            </tr>
        </>
    );
}

export default LeadItem;